<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

.spinner{
  margin-top: 40px;
  text-align: center;
}

</style>

<div class="bg">
  <div class="title-signup">Setting up...</div>
  
  <div class="spinner">
    <Spinner></Spinner>
  </div>
  
  <div class="margin small">This might take a minute.</div>
  
</div>



<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import Spinner from "../../../../components/Spinner.svelte";
import Signup from "../../../../helpers/Signup.js";

import { onMount } from "svelte";
onMount(async () => {
  
  try {
    Signup.verifyPersonalObject();
    Signup.load();
  } catch (e) {
    console.log("error:", e);
    document.location = "/";
    return;
  }
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  // generates a temp password and asks for a new UID
  await Signup.setupNewUser();
  
  push("/signup/profile/personal/birthday");
  
});


</script>